function FormulaeBiology() {
    return (
        <>
            <div className="flex h-[100vh] mx-auto p-0">
                <iframe
                    title="Concept Map"
                    width={window.innerWidth}
                    src="https://miro.com/app/live-embed/uXjVNdZYg6M=/?moveToViewport=-1402,-1001,2639,1543&embedId=626315562917&embedAutoplay=true"
                    frameBorder="0"
                    scrolling="no"
                    allow="fullscreen; clipboard-read; clipboard-write"
                    allowFullScreen
                    style={{ marginLeft: "auto", marginRight: "auto" }}
                ></iframe>
            </div>
        </>
    );
}

export default FormulaeBiology;
